import { useParams } from "react-router-dom";
import TaxTypeForm from "../../../components/forms/TaxTypeForm";
import { Fragment } from "react";

function TaxType({ filing, allowServices, onNext }) {
  const { filingUuid } = useParams();
  const handleSubmit = (updatedTaxService) => {
    onNext({
      ...filing,
      tax_service: updatedTaxService,
    });
  };
  return (
    <Fragment>
      <div>
        <TaxTypeForm
          allowServices={allowServices}
          services={filing.tax_service}
          filingUuid={filingUuid}
          onSubmit={handleSubmit}
        />
      </div>
    </Fragment>
  );
}

export default TaxType;
